
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./gsswap_sdk.cjs.production.min.js')
} else {
  module.exports = require('./gsswap_sdk.cjs.development.js')
}
